/* 登入 */
export const GET_LOGIN_API  = `/api/login/`;
export const GET_LOGOUT_API = `/api/logout/`;

/* Google 登入 */
export const POST_LOGIN_GOOGLE_API       = `/api/login/google/`;
export const GET_LOGIN_GOOGLE_CONFIG_API = `/api/login/google/config/`;

/* 版本號 */
export const GET_SYSTEM_BUILD_TIME_API = `/api/system/build-time/`;
export const GET_SYSTEM_TAIPEI_TIME_API = `/api/system/taipei-time/`;

/* 身份驗證 */
export const GET_ME_CHECK_API = `/api/me/check/`;
export const GET_ME_API       = `/api/me/`;

/* 加盟店管理 店舖總覽 */
export const GET_CLUBS_API              = `/api/clubs/`; // 舊端點保留(全量、無分頁)，前端總覽頁不再使用，改用 POST_CLUBS_OVERVIEW_API
export const POST_CLUBS_OVERVIEW_API    = `/api/clubs/overview/`;
export const GET_CLUBS_CLUBID_API       = (clubID) => `/api/clubs/${clubID}/`;
export const POST_CLUBS_API             = `/api/clubs/`;
export const PUT_CLUBS_CLUBID_API       = (clubID) => `/api/clubs/${clubID}/`;

/* 加盟店管理 公司管理 */
export const GET_COMPANIES_API             = `/api/companies/`; // 舊端點保留(全量、無分頁)，前端總覽頁不再使用，改用 POST_COMPANIES_OVERVIEW_API
export const POST_COMPANIES_OVERVIEW_API   = `/api/companies/overview/`;
export const GET_COMPANIES_OPTIONS_API     = `/api/companies/options/`;
export const GET_COMPANIES_COMPANYID_API   = (companyID) => `/api/companies/${companyID}/`;
export const POST_COMPANIES_API            = `/api/companies/`;
export const PUT_COMPANIES_COMPANYID_API   = (companyID) => `/api/companies/${companyID}/`;

/* 總部用 店舖清單 */
export const GET_CLUBS_CLUBID_USERS_API                    = (clubId) => `/api/clubs/${clubId}/users/`;
export const POST_CLUBS_CLUBID_USERS_USERID_RELATION_API   = (clubId, userId) => `/api/clubs/${clubId}/users/${userId}/relation/`;
export const DELETE_CLUBS_CLUBID_USERS_USERID_RELATION_API = (clubId, userId) => `/api/clubs/${clubId}/users/${userId}/relation/`;
export const POST_CLUBS_CLUBID_USERS_USERID_ROLES_API      = (clubId, userId) => `/api/clubs/${clubId}/users/${userId}/roles/`;

/* 加盟店管理 檢查/補建固定帳號 */
export const POST_CLUBS_CLUBID_ENSURE_ACCOUNTS_API = (clubId) => `/api/clubs/${clubId}/ensure-accounts/`;

/* 會員清單 */
export const GET_CLUBS_CLUBID_PEOPLE_API = (clubID) => `/api/clubs/${clubID}/people/`;

/* 點數換贈品相關 */
export const GET_POINTS_REWARDS_OVERVIEW_OPTIONS_API                         = `/api/points/rewards/overview/options/`;
export const GET_POINTS_REWARDS_OVERVIEW_API                                 = `/api/points/rewards/overview/`;
export const POST_PONITS_REWARDS_API                                         = `/api/points/rewards/`;
export const PUT_PONITS_REWARDS_REWARDID_API                                 = (rewardID) => `/api/points/rewards/${rewardID}`;
export const DELETE_PONITS_REWARDS_REWARDID_API                              = (rewardID) => `/api/points/rewards/${rewardID}`;
export const GET_POINTS_REWARDS_REWARDID_RECORDS_API                         = (rewardID) => `/api/points/rewards/${rewardID}/records/`;
export const GET_POINTS_REWARDS_EXPORT_API                                   = `/api/points/rewards/Export/`;
export const GET_POINTS_REWARDS_EXPORT_ALL_API                               = `/api/points/rewards/ExportAll/`;
export const GET_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_REDEEM_CART_API = (rewardID, activityID) =>
    `/api/points/rewards/${rewardID}/activity/${activityID}/redeem-cart/`;
export const POST_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_REDEEM_CART_API = GET_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_REDEEM_CART_API;
export const POST_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_UNREDEEMED_API  = (rewardID, activityID) =>
    `/api/points/rewards/${rewardID}/activity/${activityID}/un-redeem/`;
export const POST_POINTS_REWARDS_REWARDID_ACCUMULATE_API                   = (rewardID) => `/api/points/rewards/${rewardID}/accumulate/`;
export const POST_POINTS_REWARDS_REWARDID_REDEEM_STATUS_REDEEMRECORDID_API = (rewardID, redeemRecordID) =>
    `/api/points/rewards/${rewardID}/redeem-status/${redeemRecordID}/`;
export const POST_POINTS_REWARDS_REWARDID_REDEEM_COMBINE_API  = (rewardID) => `/api/points/rewards/${rewardID}/redeem-combine/`;
export const DELETE_POINTS_REWARDS_OVERVIEW_CACHE_API         = `/api/points/rewards/overview-cache`;
export const DELETE_POINTS_REWARDS_REWARDID_RECORDS_CACHE_API = (rewardID) => `/api/points/rewards/${rewardID}/records-cache`;
export const GET_POINTS_REWARDS_APPEND_OPTIONS_API            = `/api/points/rewards/append-options`;

// 點數審核
export const GET_POINT_REWARD_AUDIT_OVERVIEW_OPTIONS_API   = `/api/points/reward-audit/overview/options/`;
export const GET_POINT_REWARD_AUDIT_OVERVIEW_API           = `/api/points/reward-audit/overview/`;
export const POST_POINT_REWARD_AUDIT_API                   = `/api/points/reward-audit/`;
export const POST_POINTS_REWARD_AUDIT_SKIP_AUDIT_API       = `/api/points/reward-audit/skip-audit/`;
export const DELETE_POINTS_REWARD_AUDIT_OVERVIEW_CACHE_API = `/api/points/reward-audit/overview-cache/`;

/* 贈品清單相關 */
export const GET_POINTS_REDEEM_ORDERS_OVERVIEW_OPTIONS_API     = `/api/points/redeem-orders/overview/options/`;
export const GET_POINTS_REDEEM_ORDERS_OVERVIEW_API             = `/api/points/redeem-orders/overview/`;
export const GET_POINTS_REDEEM_ORDERS_REDEEMITEMID_RECORDS_API = (redeemItemID) => `/api/points/redeem-orders/${redeemItemID}/records/`;
export const POST_POINTS_REDEEM_ORDERS_EXPORT_API              = `/api/points/redeem-orders/export/`;
export const DELETE_POINTS_REDEEM_ORDERS_OVERVIEW_CACHE_API    = `/api/points/redeem-orders/overview-cache/`;

/* 贈品 */
export const GET_POINTS_REDEEM_ITEMS_REDEEMITEMID_API                    = (redeemItemID) => `/api/points/redeem-items/${redeemItemID}/`;
export const PUT_POINTS_REDEEM_ITEMS_REDEEMITEMID_API                    = GET_POINTS_REDEEM_ITEMS_REDEEMITEMID_API;
export const GET_POINTS_REDEEM_ITEMS_OVERVIEW_API                        = `/api/points/redeem-items/overview/`;
export const POST_POINTS_REDEEM_ITEMS_API                                = `/api/points/redeem-items/`;
export const POST_POINTS_REDEEM_ITEMS_REDEEMITEMID_THUMBNAIL_IMAGE_API   = (redeemItemID) => `/api/points/redeem-items/${redeemItemID}/thumbnail-image/`;
export const POST_POINTS_REDEEM_ITEMS_REDEEMITEMID_DESCRIPTION_IMAGE_API = (redeemItemID) => `/api/points/redeem-items/${redeemItemID}/description-image/`;
export const GET_POINTS_REDEEM_ITEMS_REDEEMITEMID_INVENTORY_API          = (redeemItemID) => `/api/points/redeem-items/${redeemItemID}/inventory/`;
export const POST_POINTS_REDEEM_ITEMS_REDEEMITEMID_INVENTORY_API         = GET_POINTS_REDEEM_ITEMS_REDEEMITEMID_INVENTORY_API;
export const PUT_POINTS_REDEEM_ITEMS_REDEEMITEMID_INVENTORY_API          = GET_POINTS_REDEEM_ITEMS_REDEEMITEMID_INVENTORY_API;

/* 點數活動 */
export const GET_POINTS_ACTIVITIES_OVERVIEW_API               = `/api/points/activities/overview`;
export const GET_POINTS_ACTIVITIES_ACTIVITYID_API             = (activityID) => `/api/points/activities/${activityID}`;
export const PUT_POINTS_ACTIVITIES_ACTIVITYID_API             = GET_POINTS_ACTIVITIES_ACTIVITYID_API;
export const POST_POINTS_ACTIVITIES_API                       = `/api/points/activities`;
export const PUT_POINTS_ACTIVITIES_ACTIVITYID_RESET_ITEMS_API = (activityID) => `/api/points/activities/${activityID}/reset-items`;

/* 左側選項清單 */
export const GET_ME_MENUS_API = '/api/me/menus/';

/* 入會申請行銷方案 */
export const GET_PROMOTION_PLAN_OPTIONS_API  = `/api/document/plans/options/`;
export const GET_PROMOTION_PLAN_OVERVIEW_API = `/api/document/plans/overview/`;
export const POST_PROMOTION_PLAN_API         = `/api/document/plans/`;
export const PUT_PROMOTION_PLAN_API          = (planID) => `/api/document/plans/${planID}/`;
export const DELETE_PROMOTION_PLAN_API       = (planID) => `/api/document/plans/${planID}/`;
export const PUT_PROMOTION_PLAN_ENABLE_API   = (planID) => `/api/document/plans/${planID}/enable/`;

/* 策略夥伴總覽 */
export const GET_CUSTOMER_RESOURCE_OVERVIEW_API = `/api/customer-resources/overview/`;
export const POST_CUSTOMER_RESOURCE_API         = `/api/customer-resources/`;
export const PUT_CUSTOMER_RESOURCE_API          = (sourceID) => `/api/customer-resources/${sourceID}/`;
export const PUT_CUSTOMER_RESOURCE_ENABLE_API   = (sourceID) => `/api/customer-resources/${sourceID}/enable/`;
export const GET_CUSTOMER_RESOURCE_SORT_API     = `/api/customer-resources/sort/`;
export const POST_CUSTOMER_RESOURCE_SORT_API    = `/api/customer-resources/sort/`;

/* 智能系統行銷方案 */
export const GET_DEVICE_ORDER_PLAN_OPTIONS_API  = `/api/cv/device-order-plans/options/`;
export const GET_DEVICE_ORDER_PLAN_OVERVIEW_API = `/api/cv/device-order-plans/overview/`;
export const POST_DEVICE_ORDER_PLAN_API         = `/api/cv/device-order-plans/`;
export const PUT_DEVICE_ORDER_PLAN_API          = (planID) => `/api/cv/device-order-plans/${planID}/`;
export const DELETE_DEVICE_ORDER_PLAN_API       = (planID) => `/api/cv/device-order-plans/${planID}/`;
export const PUT_DEVICE_ORDER_PLAN_ENABLE_API   = (planID) => `/api/cv/device-order-plans/${planID}/enable/`;

/* 循環訂單總覽 */
export const POST_CYCLE_PURCHASE_OVERVIEW_API        = `/api/cycle-purchase/overview/`;
export const GET_CYCLE_PURCHASE_OVERVIEW_OPTIONS_API = `/api/cycle-purchase/overview/options/`;

/* 會員循環訂單收費明細 */
export const POST_MEMBERS_CYCLE_PURCHASE_ORDERS_API = (memberID, cycleOrderID) => `api/members/${memberID}/cycle-purchase/${cycleOrderID}/orders/`;

/* 三個月刷卡失敗的循環訂單資訊 */
export const GET_ORDERS_CYCLE_PURCHASE_PAYMENT_ERRORS_API  = `/api/orders/cycle-purchases/payment-errors`;
export const POST_ORDERS_CYCLE_PURCHASE_PAYMENT_ERRORS_API = (cycleOrderID) => `/api/orders/cycle-purchases/${cycleOrderID}`;

// 循環主單
export const GET_CYCLE_PURCHASE_DETAIL_API         = (cycleOrderID) => `/api/cycle-purchase/${cycleOrderID}/`;
export const GET_CYCLE_PURCHASE_DETAIL_HISTORY_API = (memberID, cycleOrderID) => `/api/members/${memberID}/cycle-purchase/${cycleOrderID}/history/`;
export const GET_CYCLE_PURCHASE_DETAIL_FUTURE_API  = (memberID, cycleOrderID) => `/api/members/${memberID}/cycle-purchase/${cycleOrderID}/future/`;
export const GET_CYCLE_PURCHASE_DETAIL_EFFECT_API  = (cycleOrderID, effectID) => `/api/cycle-purchase/${cycleOrderID}/effection/${effectID}`;
// 循環主單PDF
export const GET_CYCLE_PURCHASE_DETAIL_PDF_API        = (memberID, cycleOrderID) => `/members/${memberID}/doc/cycle-purchase/${cycleOrderID}/contract.pdf`;
export const GET_CYCLE_PURCHASE_DETAIL_PDF_EFFECT_API = (memberID, effectID) => `/members/${memberID}/doc/cycle-purchase-effection/${effectID}/contract.pdf`;


/* 循環訂單檢核扣款 */
export const GET_CYCLE_PURCHASE_TASKS_OVERVIEW_OPTIONS_API = `/api/cycle-purchase-tasks/overview/options/`;
export const GET_CYCLE_PURCHASE_TASKS_OVERVIEW_API         = `/api/cycle-purchase-tasks/overview/`;
export const GET_CYCLE_PURCHASE_TASKS_API                  = (taskID) => `/api/cycle-purchase-tasks/${taskID}/`;
export const DELETE_CYCLE_PURCHASE_TASKS_API               = (taskID) => `/api/cycle-purchase-tasks/${taskID}/`;
export const POST_CYCLE_PURCHASE_TASKS_UPLOAD_EXCEL_API    = (shippingMonth, shippingDay) => `/api/cycle-purchase-tasks/${shippingMonth}/type/${shippingDay}/upload/`;
export const POST_CYCLE_PURCHASE_TASKS_SETTLE_API          = (taskID) => `/api/cycle-purchase-tasks/${taskID}/settle/`;
export const POST_CYCLE_PURCHASE_TASKS_RETURN_UPLOAD_EXCEL_API = (shippingMonth, shippingDay) => `/api/cycle-purchase-tasks/${shippingMonth}/type/${shippingDay}/return/upload/`;
export const POST_CYCLE_PURCHASE_TASKS_RETURN_SETTLE_API       = (taskID) => `/api/cycle-purchase-tasks/${taskID}/return/settle/`;

/* Dashboard */
export const POST_CHART_ADV_FILTER_TAGGED_API     = '/api/charts/adv/tagged-filter';
export const POST_CHART_ADV_FILTER_STATISTICS_API = '/api/charts/adv/statistics-filter';
export const GET_CHART_ADV_FILTER_OPTIONS_API     = '/api/charts/adv/options';

/* 設備租賃 */
export const GET_DEVICE_ORDER_TASKS_OVERVIEW_OPTIONS_API = `/api/device-order-tasks/overview/options/`;
export const GET_DEVICE_ORDER_TASKS_OVERVIEW_API         = `/api/device-order-tasks/overview/`;
export const GET_DEVICE_ORDER_TASKS_API                  = (taskID) => `/api/device-order-tasks/${taskID}/`;
export const DELETE_DEVICE_ORDER_TASKS_API               = (taskID) => `/api/device-order-tasks/${taskID}/`;
export const POST_DEVICE_ORDER_TASKS_SETTLE_API          = (shippingMonth, shippingDay) => `/api/device-order-tasks/${shippingMonth}/type/${shippingDay}/upload/`;
export const POST_DEVICE_ORDER_TASKS_EXPORT_API          = (shippingMonth, shippingDay) => `/api/device-order-tasks/${shippingMonth}/type/${shippingDay}/upload/`;

/* 店舖下拉選單 */
export const GET_CLUBS_OPTIONS_API = `/api/clubs/options/`;

/* HQ 店舖庫存選項 */
export const GET_CLUB_INVENTORY_OPTIONS_API = `/api/club-inventory/options`;

/* HQ 店舖庫存總覽 */
export const POST_CLUB_INVENTORY_OVERVIEW_API = `/api/club-inventory/overview`;

/* HQ 店舖庫存異動紀錄 */
export const POST_CLUB_INVENTORY_RECORDS_API = `/api/club-inventory/records`;

/* HQ 店舖庫存瑕疵紀錄 */
export const POST_CLUB_INVENTORY_DEFECTIVE_RECORDS_API = `/api/club-inventory/defective-records`;

/* HQ 商品庫存總覽（商品角度） */
export const POST_CLUB_INVENTORY_PRODUCT_STOCK_OVERVIEW_API = `/api/club-inventory-product/overview`;

/* HQ 商品庫存明細（商品角度） */
export const POST_CLUB_INVENTORY_PRODUCT_STOCK_DETAIL_API = `/api/club-inventory-product/detail`;

/* 成績單 */
export const GET_JSON_PERCENTILE_RANK_API = `/api/json/percentile-rank/`;

/* 訂單 */
export const GET_ORDERS_OVERVIEW_OPTIONS_API = `/api/orders/overview/options/`;
export const GET_ORDERS_ORDER_API = (orderID) => `/api/orders/${orderID}/`;
export const GET_ORDERS_REISSUING_DIALOG_API = (orderID) => `/api/orders/${orderID}/reissuing-dialog/`;
export const POST_ORDERS_OVERVIEW_API = `/api/orders/overview/`;
export const POST_ORDERS_OVERVIEW_ADVANCE_API = `/api/orders/overview/advance/`;
export const POST_ORDERS_REISSUING_API = (orderID) => `/api/orders/${orderID}/reissuing/`;
export const PUT_ORDERS_REISSUING_API = (orderID) => `/api/orders/${orderID}/reissuing/`;
export const PUT_ORDERS_DELETE_API = (orderID) => `/api/orders/${orderID}/delete/`;
export const PUT_ORDERS_REINIT_API = (orderID) => `/api/orders/${orderID}/reinit/`;

/* 退單 */
export const GET_ORDER_RETURS_ALLOWANCE_DIALOG_API = (orderID) => `/api/orders/return/${orderID}/allowance-dialog/`;
export const POST_ORDER_RETURN_ALLOWANCE_CONFIRM_API = `/api/orders/return/allowance-confirm/`;
export const GET_ORDER_RETURN_INVALID_DIALOG_API = (orderID) => `/api/orders/return/${orderID}/invalid-dialog/`;
export const POST_ORDER_RETURN_INVALID_CONFIRM_API = `/api/orders/return/invalid-confirm/`;
export const POST_ORDER_RETURN_INVALID_AGAIN_API = (returnID) => `/api/orders/return/invalid-again/${returnID}`;
export const GET_ORDER_RETURN_ALLOWANCE_HISTORY_API = (orderID) => `/api/orders/return/${orderID}/allowance-history/`;
export const POST_ORDER_RETURN_INVALID_ALLOWANCE_CONFIRM_API = `/api/orders/return/invalid-allowance-confirm/`;

/* 三聯式發票退單折讓 */
export const GET_INVOICE_TRIPLICATE_UNIFORM_OVERVIEW_OPTIONS_API =
	`/api/invoice-allowance/triplicate-uniform/overview/options`;
export const POST_INVOICE_TRIPLICATE_UNIFORM_OVERVIEW_API = `/api/invoice-allowance/triplicate-uniform/overview`;
export const DELETE_INVOICE_TRIPLICATE_UNIFORM_OVERVIEW_CACHE_API =
	`/api/invoice-allowance/triplicate-uniform/overview-cache`;
export const GET_INVOICE_TRIPLICATE_UNIFORM_CONFIRM_DOC_API = (orderID, orderReturnID, extension) =>
	`/pdf/orders/${orderID}/returns/${orderReturnID}/doc/triplicate-uniform-confirm.${extension}`;
export const PUT_INVOICE_TRIPLICATE_UNIFORM_CONFIRM_API = (orderID, orderReturnID) =>
	`/api/invoice-allowance/triplicate-uniform/${orderID}/returns/${orderReturnID}/confirm`;
export const PUT_INVOICE_TRIPLICATE_UNIFORM_RESET_API = (orderID, orderReturnID) =>
	`/api/invoice-allowance/triplicate-uniform/${orderID}/returns/${orderReturnID}/reset`;

/* 商品管理 */
export const GET_PRODUCT_OPTIONS_API = `/api/product/options`;
export const POST_PRODUCT_OVERVIEW_API = `/api/product/overview`;
export const GET_PRODUCT_DETAIL_API = (productID) => `/api/product/${productID}`;
export const POST_PRODUCT_API = `/api/product`;
export const PUT_PRODUCT_API = (productID) => `/api/product/${productID}`;
export const PUT_PRODUCT_ENABLED_API = `/api/product/enable`;
